/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import { isPlatformBrowser } from '@angular/common';
import { FactoryProvider, InjectionToken, PLATFORM_ID } from '@angular/core';

export const WINDOW = new InjectionToken('WindowToken');

function windowFactory(platformId: Object): Window | Object {
  return isPlatformBrowser(platformId) ? window : {};
}

/**
 * Provides am injectable reference to the Browser's global `window` object.
 */
export const WindowProvider: FactoryProvider = {
  provide: WINDOW,
  useFactory: windowFactory,
  deps: [PLATFORM_ID],
};
